<template>
    <md-snackbar :md-position="position"
                 :md-duration="isInfinity ? Infinity : duration"
                 :md-active.sync="showSnackbar"
                 @md-closed="onClosed"
                 @md-opened="onOpened"
                 md-persistent>
        <span>{{msg}}</span>
        <md-button class="md-primary" @click="showSnackbar = false">
            <md-icon>close</md-icon>
        </md-button>
    </md-snackbar>
</template>

<script>
    import NotifyPlugin from './plugin.js';

    function getDefaultData() {
        return {
            position: 'center',
            duration: 4000,
            showSnackbar: false,
            isInfinity: false,
            msg: '...'
        }
    }

    export default {
        name: 'Notify',
        data: getDefaultData,
        methods: {
            showDuration(params) {
                this.position = params.position;
                this.duration = params.duration;
                this.msg = params.msg;
                this.showSnackbar = true;
            },
            showInfinite(params) {
                this.position = params.position;
                this.msg = params.msg;
                this.isInfinity = true;
                this.showSnackbar = true;
            },
            onClosed() {
                Object.assign(this.$data, getDefaultData());
            },
            onOpened() {
            }
        },
        beforeMount() {
            NotifyPlugin.EventBus.$on('showDuration', (params) => {
                this.showDuration(params);
            });

            NotifyPlugin.EventBus.$on('showInfinite', (params) => {
                this.showInfinite(params);
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>